import {EditorState, StateEffect, StateField} from '@codemirror/state'
import {EditorView} from '@codemirror/view'

/** Effect that will be triggered when shift key is pressed or lifted.*/
const shiftPressedChangeEffect = StateEffect.define<boolean>()

const shiftKeyObserver = EditorView.domEventObservers({
  keydown(event, view) {
    // eslint-disable-next-line @github-ui/ui-commands/no-manual-shortcut-logic
    if (event.key === 'Shift' && !isShiftPressed(view.state))
      view.dispatch({effects: shiftPressedChangeEffect.of(true)})
  },
  keyup(event, view) {
    // eslint-disable-next-line @github-ui/ui-commands/no-manual-shortcut-logic
    if (event.key === 'Shift' && isShiftPressed(view.state))
      view.dispatch({effects: shiftPressedChangeEffect.of(false)})
  },
  blur(event, view) {
    if (isShiftPressed(view.state)) view.dispatch({effects: shiftPressedChangeEffect.of(false)})
  },
})

/** Field to store the shift key pressed state on the editor state. */
const isShiftPressedField = StateField.define<boolean>({
  create: () => false,
  update: (prev, tr) => tr.effects.find(eff => eff.is(shiftPressedChangeEffect))?.value ?? prev,
  provide: () => [shiftKeyObserver],
})

/** Extension that tracks when the user is pressing the shift key in the editor. */
export const shiftPressedExtension = [isShiftPressedField]

/** Get the shift key state from the editor state. Throws an error if `shiftPressedExtension` is not installed. */
export function isShiftPressed(state: EditorState) {
  return state.field(isShiftPressedField)
}
